import { Button } from "@southfields-digital/mxmz-react-ui";

type AddButtonProps = {
	onClick: () => void;
};

const AddButton = ({ onClick }: AddButtonProps) => (
	<Button buttonSize="small" onClick={onClick} iconProps={{ icon: "plus", weight: "bold" }} />
);

export default AddButton;
